import { render, staticRenderFns } from "./price-bill-text-tips.vue?vue&type=template&id=6dbe3a8c&scoped=true"
import script from "./price-bill-text-tips.vue?vue&type=script&lang=js"
export * from "./price-bill-text-tips.vue?vue&type=script&lang=js"
import style0 from "./price-bill-text-tips.vue?vue&type=style&index=0&id=6dbe3a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe3a8c",
  null
  
)

export default component.exports